import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUp } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/Grid/SnGrid";
import SnTab from "@shared/components/SnTab";
import { showDialog } from "@widgets/CommonDialog";

interface popupProps {
  modalRef?: any;
}

const SN_MAS_SET_REG_003_POP_001 = forwardRef(
  ({ modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion

    //#region Components useState
    const [columns1, setColums1] = useState<any[]>([]);
    const [columns2, setColums2] = useState<any[]>([]);
    const [columns3, setColums3] = useState<any[]>([]);
    const [dataSource1, setDataSource1] = useState<any[]>([]);
    const [dataSource2, setDataSource2] = useState<any[]>([]);
    const [dataSource3, setDataSource3] = useState<any[]>([]);

    const gridref1 = useRef<any>(null);
    const gridref2 = useRef<any>(null);
    const gridref3 = useRef<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      checkValidity: async () => {
        gridref1.current?.api.stopEditing();
        gridref2.current?.api.stopEditing();
        gridref3.current?.api.stopEditing();

        await new Promise((resolve) => setTimeout(resolve, 0));

        const requiredValuesCheck1 = gridref1.current.requiredValuesCheck();
        if (!requiredValuesCheck1) return;

        const requiredValuesCheck2 = gridref2.current.requiredValuesCheck();
        if (!requiredValuesCheck2) return;

        const requiredValuesCheck3 = gridref3.current.requiredValuesCheck();
        if (!requiredValuesCheck3) return;

        const changes1 = gridref1.current.getChange();
        const changes2 = gridref2.current.getChange();
        const changes3 = gridref3.current.getChange();

        const isModified =
          (changes1?.modifiedRowcount || 0) > 0 ||
          (changes2?.modifiedRowcount || 0) > 0 ||
          (changes3?.modifiedRowcount || 0) > 0;
        let lsChk: any = "2";
        if (!isModified) {
          lsChk = "1";
        } else {
          lsChk = "2";
        }

        if (lsChk === "1") {
          return { flag: false, message: "변경된 내용이 없습니다." };
        }
        return { flag: true };
      },
      getSelectedValue: async () => {
        await onSave();
        return "success";
      },
      getSelectedRow: () => [gridref1.current.getSelectedRows() || []],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUp("SN_MAS_SET_REG_003_POP_001", {});
          setColums1(rtn.grid.grid1);
          setColums2(rtn.grid.grid2);
          setColums3(rtn.grid.grid3);

          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, []);

    //#region onSearch
    const onSearch = () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_mas_set_reg_003_pop_001_02",
            params: { cd_firm: userInfo.cd_firm },
          };

          setDataSource1([]);
          setDataSource2([]);
          setDataSource3([]);
          const data: any = await fnGetDataSet(params);

          setDataSource1(data[0]);
          setDataSource2(data[1] || []);
          setDataSource3(data[2] || []);

          if (data[0] && data[0].length > 0) {
            await new Promise((resolve) => setTimeout(resolve, 50));

            gridref1.current.selectAndFocusRow(0);
            gridref2.current.selectAndFocusRow(0);
            gridref3.current.selectAndFocusRow(0);
          }

          gridref1.current.resetUpdate();
          gridref2.current.resetUpdate();
          gridref3.current.resetUpdate();
        } catch (error) {}
      };
      fetchdatasource();
    };

    const onSave = async () => {
      try {
        gridref1.current.api.stopEditing() ||
          gridref2.current.api.stopEditing() ||
          gridref3.current.api.stopEditing();

        const changes1 = gridref1.current.getChange(); // PKG
        const changes2 = gridref2.current.getChange(); // SPEC
        const changes3 = gridref3.current.getChange(); // ETC

        const allChanges = [
          ...(changes1.insert || []),
          ...(changes1.update || []),

          ...(changes2.insert || []),
          ...(changes2.update || []),

          ...(changes3.insert || []),
          ...(changes3.update || []),
        ];

        const mergedMap = new Map<string | number, any>();
        allChanges.forEach((row) => {
          const id = row.nm_column;
          if (!id) return;

          if (mergedMap.has(id)) {
            const existing = mergedMap.get(id);
            mergedMap.set(id, { ...existing, ...row });
          } else {
            mergedMap.set(id, row);
          }
        });

        const combinedChanges = Array.from(mergedMap.values());
        if (combinedChanges.length === 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }
        const SaveData = {
          sys_config_format: { update: combinedChanges },
        };

        await fnSave("SN_MAS_SET_REG_003_SAVE_O1", SaveData);

        //modalRef.current?.handleConfirm?.(true, "close");
      } catch (error: any) {}
    };

    //#endregion

    //#region UI
    return (
      <div className="h-full flex flex-col">
        <SnTab
          titles={["표준", "규격", "기타"]}
          width={"100%"}
          body={[
            <SnGrid
              ref={gridref1}
              columnConfig={columns1}
              rowData={dataSource1}
              isEditable={true}
              rowSelection="single"
            />,
            <SnGrid
              ref={gridref2}
              isEditable={true}
              rowSelection="single"
              columnConfig={columns2}
              rowData={dataSource2}
            />,
            <SnGrid
              ref={gridref3}
              isEditable={true}
              rowSelection="single"
              columnConfig={columns3}
              rowData={dataSource3}
            />,
          ]}
        />
      </div>
    );
  }
  //#endregion
);

export default SN_MAS_SET_REG_003_POP_001;
